export default {
  titulo: 'Specific Legislation for Aerodromes and Objects Projected in Airspace',
};
